import React from 'react';

import SettingsPageLayoutNE from '../Layout/SettingsPageLayoutNE/SettingsPageLayoutNE';
import SlackCard from './sections/Slack/SlackCard';

import './SettingsIntegrations.scss';

const SettingsIntegrations = () => {
  return (
    <SettingsPageLayoutNE>
      <div className="settings-integrations-content">
        <SlackCard />
      </div>
    </SettingsPageLayoutNE>
  );
};

export default SettingsIntegrations;
